<router-outlet />
<p-confirmDialog  rejectButtonStyleClass="p-button-text"></p-confirmDialog>
@if(appService.loading){
  <div class="progress-spinner"  style="z-index:999999999;">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-toast></p-toast>

